// extracted by mini-css-extract-plugin
export var emptyCartContainer = "EmptyCart-module--emptyCartContainer--33-Xf";
export var contentWrapper = "EmptyCart-module--contentWrapper--31fDq";
export var buttonWrapper = "EmptyCart-module--buttonWrapper--1xx56";